function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60px",
    height: "60px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.102
    },
    fill: "#aedafa",
    d: "M 41.5,0.5 C 41.5,4.83333 41.5,9.16667 41.5,13.5C 40.5184,10.0381 40.185,6.37141 40.5,2.5C 30.5,2.5 20.5,2.5 10.5,2.5C 9.96438,5.69805 10.631,8.36472 12.5,10.5C 11.1667,11.8333 9.83333,11.8333 8.5,10.5C 8.5,7.16667 8.5,3.83333 8.5,0.5C 19.5,0.5 30.5,0.5 41.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5fafe",
    d: "M 41.5,13.5 C 42.1408,14.4822 42.8075,15.4822 43.5,16.5C 37.2015,17.4963 30.8682,17.8297 24.5,17.5C 24.8064,14.6146 24.4731,11.9479 23.5,9.5C 19.8212,9.72442 16.1545,10.0578 12.5,10.5C 10.631,8.36472 9.96438,5.69805 10.5,2.5C 20.5,2.5 30.5,2.5 40.5,2.5C 40.185,6.37141 40.5184,10.0381 41.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.767
    },
    fill: "#5eb1f1",
    d: "M 41.5,0.5 C 46.2077,4.20661 50.2077,8.53994 53.5,13.5C 52.8333,13.5 52.1667,13.5 51.5,13.5C 48.1667,13.5 44.8333,13.5 41.5,13.5C 41.5,9.16667 41.5,4.83333 41.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e7f8",
    d: "M 41.5,13.5 C 44.8333,13.5 48.1667,13.5 51.5,13.5C 51.5,17.8333 51.5,22.1667 51.5,26.5C 49.4017,25.0857 48.4017,25.7524 48.5,28.5C 40.5,28.5 32.5,28.5 24.5,28.5C 31.989,27.671 39.6557,27.171 47.5,27C 16.8549,26.1638 16.8549,24.9972 47.5,23.5C 16.8621,21.8372 16.8621,20.8372 47.5,20.5C 47.5,19.5 47.5,18.5 47.5,17.5C 39.6917,18.7475 32.025,18.7475 24.5,17.5C 30.8682,17.8297 37.2015,17.4963 43.5,16.5C 42.8075,15.4822 42.1408,14.4822 41.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0f7fe",
    d: "M 51.5,26.5 C 51.5,35.5 51.5,44.5 51.5,53.5C 37.8333,53.5 24.1667,53.5 10.5,53.5C 9.96438,50.3019 10.631,47.6353 12.5,45.5C 15.1667,45.8333 17.8333,46.1667 20.5,46.5C 21.5676,47.4345 22.901,47.7678 24.5,47.5C 24.5,45.8333 24.5,44.1667 24.5,42.5C 41.7825,42.4941 41.7825,41.8275 24.5,40.5C 55.1667,39.1667 55.1667,37.8333 24.5,36.5C 55.1667,35.1667 55.1667,33.8333 24.5,32.5C 32.1667,31.8333 39.8333,31.1667 47.5,30.5C 39.6771,29.8333 32.0104,29.1666 24.5,28.5C 32.5,28.5 40.5,28.5 48.5,28.5C 48.4017,25.7524 49.4017,25.0857 51.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9cff2",
    d: "M 23.5,9.5 C 24.4731,11.9479 24.8064,14.6146 24.5,17.5C 32.025,18.7475 39.6917,18.7475 47.5,17.5C 47.5,18.5 47.5,19.5 47.5,20.5C 16.8621,20.8372 16.8621,21.8372 47.5,23.5C 16.8549,24.9972 16.8549,26.1638 47.5,27C 39.6557,27.171 31.989,27.671 24.5,28.5C 32.0104,29.1666 39.6771,29.8333 47.5,30.5C 39.8333,31.1667 32.1667,31.8333 24.5,32.5C 55.1667,33.8333 55.1667,35.1667 24.5,36.5C 55.1667,37.8333 55.1667,39.1667 24.5,40.5C 41.7825,41.8275 41.7825,42.4941 24.5,42.5C 24.5,44.1667 24.5,45.8333 24.5,47.5C 22.901,47.7678 21.5676,47.4345 20.5,46.5C 21.5,46.5 22.5,46.5 23.5,46.5C 23.5,34.1667 23.5,21.8333 23.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#30589a",
    d: "M 23.5,9.5 C 23.5,21.8333 23.5,34.1667 23.5,46.5C 22.5,46.5 21.5,46.5 20.5,46.5C 17.8333,46.1667 15.1667,45.8333 12.5,45.5C 11.1667,44.1667 9.83333,44.1667 8.5,45.5C 5.93562,45.0213 3.43562,44.3547 1,43.5C 0.167704,33.1506 0.334371,22.8172 1.5,12.5C 3.86311,11.8298 6.19644,11.1632 8.5,10.5C 9.83333,11.8333 11.1667,11.8333 12.5,10.5C 16.1545,10.0578 19.8212,9.72442 23.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfe5ef",
    d: "M 15.5,21.5 C 16.5,21.5 17.5,21.5 18.5,21.5C 17.3633,25.4172 16.53,29.4172 16,33.5C 14.9887,34.3366 13.8221,34.67 12.5,34.5C 12.7989,32.396 12.4656,30.396 11.5,28.5C 10.5481,30.0453 10.2148,31.712 10.5,33.5C 9.32496,33.719 8.32496,33.3857 7.5,32.5C 6.7807,29.6875 6.11403,26.8541 5.5,24C 5.83333,23.5 6.16667,23 6.5,22.5C 7.58359,23.6651 8.41692,24.9984 9,26.5C 9.49001,25.2068 9.65668,23.8734 9.5,22.5C 10.8333,22.5 12.1667,22.5 13.5,22.5C 14.231,28.8167 14.8977,28.4833 15.5,21.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.258
    },
    fill: "#a8d2f6",
    d: "M 51.5,13.5 C 52.1667,13.5 52.8333,13.5 53.5,13.5C 53.5,27.5 53.5,41.5 53.5,55.5C 38.5,55.5 23.5,55.5 8.5,55.5C 8.5,52.1667 8.5,48.8333 8.5,45.5C 9.83333,44.1667 11.1667,44.1667 12.5,45.5C 10.631,47.6353 9.96438,50.3019 10.5,53.5C 24.1667,53.5 37.8333,53.5 51.5,53.5C 51.5,44.5 51.5,35.5 51.5,26.5C 51.5,22.1667 51.5,17.8333 51.5,13.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.a3e9724060609e5bcfd0814bb1bc6853.svg";
export { ForwardRef as ReactComponent };